import { UserAlert } from "state/models/UserAlert.model";
import { UserAlertState } from "state/reducers/userAlertReducers";

export const getVisibleUserAlerts = (state: UserAlertState): UserAlert[] => state.userAlerts.filter((ua) => ua.isDisplayed);
